(function () {
    'use strict';

    angular.module('app')
        .controller('AyudaController', AyudaController);

    /* @ngInject */
    function AyudaController(ModalService) {
        var vm = this;
        vm.dismiss = ModalService.dismiss;

    }
})();
